/* eslint-disable import/prefer-default-export */
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { RUMUtil, CWRUMUtil } from 'wcng-ui-common';

import { LanguageTranslators } from './constants';
import Config from './configs/config';

export const initI18n = () => {
  // set up language translations
  const resources = Object.entries(LanguageTranslators)
    .reduce((res, [key, { translation }]) => ({
      ...res,
      [key]: {
        translation
      }
    }), {});

  i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      resources,
      fallbackLng: 'en-US',
      interpolation: {
        escapeValue: false
      }
    });

  let previousLang = i18next.language;
  i18next.on('languageChanged', (lang) => {
    const { useDatadogRUM, useCloudWatchRUM } = Config;
    if (!resources[lang]) {
        if (useDatadogRUM) {
          RUMUtil.addAction(`registration_language_not_supported[${lang}]`);
        }
        if (useCloudWatchRUM) {
          CWRUMUtil.addAction(`registration_language_not_supported[${lang}]`);
        }
        i18next.changeLanguage('en-US');
    } else {
      if (lang !== previousLang) {
        if (useDatadogRUM) {
          RUMUtil.addAction(`registration_select_language[${lang}]`);
        }
        if (useCloudWatchRUM) {
          CWRUMUtil.addAction(`registration_select_language[${lang}]`);
        }
      }
    }
    previousLang = lang;
  });

  // LanguageDetector first run
  i18next.changeLanguage();
};
